import React, { SVGProps } from 'react';

export const SearchClearIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 32 32"
    fill="none"
    {...props}>
    <path
      fill="currentColor"
      d="M24.667 25.667c-0.253 0-0.507-0.093-0.707-0.293l-7.96-7.96-7.96 7.96c-0.387 0.387-1.027 0.387-1.413 0s-0.387-1.027 0-1.413l7.96-7.96-7.96-7.96c-0.387-0.387-0.387-1.027 0-1.413s1.027-0.387 1.413 0l7.96 7.96 7.96-7.96c0.387-0.387 1.027-0.387 1.413 0s0.387 1.027 0 1.413l-7.96 7.96 7.96 7.96c0.387 0.387 0.387 1.027 0 1.413-0.2 0.2-0.453 0.293-0.707 0.293z"
    />
  </svg>
);
